














































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class DisableSellCoins extends Vue {
  @Prop() onConfirm!: any;

  loading: boolean = false;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  async handleConfirm() {
    this.loading = true;
    await this.onConfirm();
    this.loading = false;
    this.handleClose();
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }
}
